import React from "react";
import { WarningOctagon, Warning } from "@phosphor-icons/react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const AddAlertDialog = ({ alert, onClose, onConfirm }) => {
  const isDup = alert?.type === "duplicate";
  return (
    <AlertDialog open={!!alert} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent className={`rounded-none border-4 ${isDup ? "border-red-600" : "border-amber-500"}`} data-testid="toll-add-alert">
        <AlertDialogHeader>
          <AlertDialogTitle className={`flex items-center gap-2 text-xl uppercase tracking-wide ${isDup ? "text-red-600" : "text-amber-700"}`}>
            {isDup ? <WarningOctagon size={28} weight="fill" /> : <Warning size={28} weight="fill" />}
            {isDup ? "N° déjà existant" : "Camion déjà équipé"}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-base text-zinc-800" data-testid="toll-add-alert-message">
            {isDup ? (
              <>Le télépéage <b>N°{alert.number}</b> existe déjà{alert.plate ? <> (attribué au camion <b>{alert.plate}</b>)</> : " (sans camion)"}. Choisissez un autre numéro.</>
            ) : (
              <>Le camion <b>{alert?.plate}</b> a déjà le télépéage <b>N°{alert?.existing}</b>. Si vous continuez, le N°{alert?.existing} sera retiré de ce camion et remplacé par le <b>N°{alert?.number}</b>.</>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {isDup ? (
            <AlertDialogAction className="rounded-none bg-red-600 hover:bg-red-700" data-testid="toll-add-alert-ok">Compris</AlertDialogAction>
          ) : (
            <>
              <AlertDialogCancel className="rounded-none" data-testid="toll-add-alert-cancel">Annuler</AlertDialogCancel>
              <AlertDialogAction onClick={onConfirm} className="rounded-none bg-amber-600 hover:bg-amber-700" data-testid="toll-add-alert-confirm">
                Remplacer le N°{alert?.existing}
              </AlertDialogAction>
            </>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
